export { default } from './svg';
